import { Col, Form, FormFeedback, Input, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap"

import PropTypes from 'prop-types'
import React from "react"
import Select from 'react-select';
import { useFormik } from "formik";
import * as Yup from 'yup';
import * as CONSTANTS from 'common/utils/data_validations';
import { MODE } from "helpers/sf_constants";
import { getOptionFromValueForSelectBox, getPrimaryButtonClass, getPrimaryTextClass } from "helpers/sf_utils";
import { optionsRevenueOrPayRoll, optionsTypeOfEntity } from "helpers/sf_lead_constants";


const AddBusinessEntityModal = ({ title, show, onClickBusinessEntity, onCloseClick }) => {

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            id: show?.mode === MODE.EDIT ? show?.values?.id : null,
            business_name: show?.mode === MODE.EDIT ? show?.values?.business_name : "",
            business_desc: show?.mode === MODE.EDIT ? show?.values?.business_desc : "",
            yrs_in_business: show?.mode === MODE.EDIT ? show?.values?.yrs_in_business : "",
            num_partners: show?.mode === MODE.EDIT ? show?.values?.num_partners : "",
            legal_entity: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsTypeOfEntity, show?.values?.legal_entity) : "",
            annual_revenue: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsRevenueOrPayRoll, show?.values?.annual_revenue) : "",
            annual_payroll: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsRevenueOrPayRoll, show?.values?.annual_payroll) : "",
            num_full_time_employees: show?.mode === MODE.EDIT ? show?.values?.num_full_time_employees : "",
            num_part_time_employees: show?.mode === MODE.EDIT ? show?.values?.num_part_time_employees : ""
        },
        validationSchema: Yup.object({
            business_name: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            business_desc: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            yrs_in_business: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            num_partners: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            num_full_time_employees: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            num_part_time_employees: Yup.string(),
            legal_entity: Yup.object().shape({
                label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
              }),
            annual_revenue: Yup.object().shape({
                label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                }),
            annual_payroll: Yup.object().shape({
                label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                }),
        }),
        onSubmit: (values) => {
            onClickBusinessEntity(show?.mode, {...values, 
                legal_entity: values.legal_entity.value,
                annual_revenue: values.annual_revenue.value,
                annual_payroll: values.annual_payroll.value,
            });
        },
    });


  return (
    <Modal isOpen={show?.active} toggle={onCloseClick} centered={true} size='xl'>
      <ModalHeader>
        <div className="d-flex justify-content-center">
            <i className={`align-self-bottom label-title bx bx-users ${getPrimaryTextClass()} me-1`}></i>
            <span className="modal-title font-weight-semibold text-black">
                {title}
            </span>
        </div>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={onCloseClick}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <ModalBody>
      <Form
            onSubmit={e => {
                e.preventDefault();
                validation.handleSubmit()
                return false
            }}
        >
            <Row className="mx-2">
                <Col md={4} className='pe-3'>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Business Name</Label>
                        <Input
                            type='text'
                            name="business_name"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.business_name || ''}
                            invalid={
                                !!(validation.touched.business_name
                                    && validation.errors.business_name)
                            }
                        />
                        {validation.touched.business_name
                            && validation.errors.business_name ? (
                            <FormFeedback type="invalid">
                                {validation.errors.business_name}
                            </FormFeedback>
                        ) : null}
                    </Col>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Business Description</Label>
                        <Input
                            type='text'
                            name="business_desc"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.business_desc || ''}
                            invalid={
                                !!(validation.touched.business_desc
                                    && validation.errors.business_desc)
                            }
                        />
                        {validation.touched.business_desc
                            && validation.errors.business_desc ? (
                            <FormFeedback type="invalid">
                                {validation.errors.business_desc}
                            </FormFeedback>
                        ) : null}
                    </Col>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Years in Business</Label>
                        <Input
                            type='text'
                            name="yrs_in_business"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.yrs_in_business || ''}
                            invalid={
                                !!(validation.touched.yrs_in_business
                                    && validation.errors.yrs_in_business)
                            }
                        />
                        {validation.touched.yrs_in_business
                            && validation.errors.yrs_in_business ? (
                            <FormFeedback type="invalid">
                                {validation.errors.yrs_in_business}
                            </FormFeedback>
                        ) : null}
                    </Col>
                </Col>
                <Col md={4} className='pe-3'>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">No. of Partners</Label>
                        <Input
                            type='text'
                            name="num_partners"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.num_partners || ''}
                            invalid={
                                !!(validation.touched.num_partners
                                    && validation.errors.num_partners)
                            }
                        />
                        {validation.touched.num_partners
                            && validation.errors.num_partners ? (
                            <FormFeedback type="invalid">
                                {validation.errors.num_partners}
                            </FormFeedback>
                        ) : null}
                    </Col>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Full Time Employees</Label>
                        <Input
                            type='text'
                            name="num_full_time_employees"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.num_full_time_employees || ''}
                            invalid={
                                !!(validation.touched.num_full_time_employees
                                    && validation.errors.num_full_time_employees)
                            }
                        />
                        {validation.touched.num_full_time_employees
                            && validation.errors.num_full_time_employees ? (
                            <FormFeedback type="invalid">
                                {validation.errors.num_full_time_employees}
                            </FormFeedback>
                        ) : null}
                    </Col>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Part Time Employees</Label>
                        <Input
                            type='text'
                            name="num_part_time_employees"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.num_part_time_employees || ''}
                            invalid={
                                !!(validation.touched.num_part_time_employees
                                    && validation.errors.num_part_time_employees)
                            }
                        />
                        {validation.touched.num_part_time_employees
                            && validation.errors.num_part_time_employees ? (
                            <FormFeedback type="invalid">
                                {validation.errors.num_part_time_employees}
                            </FormFeedback>
                        ) : null}
                    </Col>
                </Col>
                <Col md={4} className='pe-3'>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Type of Entity</Label>
                        <Select
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            menuShouldBlockScroll='true'
                            options={optionsTypeOfEntity}
                            onChange={(selectedOption) => {
                                const event = {
                                    target: {
                                        name: 'legal_entity',
                                        value: selectedOption,
                                    },
                                };
                                validation.handleChange(event);
                            }}
                            onBlur={() => {
                                validation.handleBlur({
                                    target: { name: 'legal_entity' },
                                });
                            }}
                            value={validation.values.legal_entity || ''}
                            invalid={
                                !!(validation.touched.legal_entity
                                    && validation.errors.legal_entity)
                            }
                        />
                            {validation.touched.legal_entity
                            && validation.errors.legal_entity ? (
                            <span className="text-danger">
                                {CONSTANTS.STR_REQUIRED_FIELD}
                            </span>
                        ) : null}
                    </Col>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Annual Revenue</Label>
                        <Select
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            menuShouldBlockScroll='true'
                            options={optionsRevenueOrPayRoll}
                            onChange={(selectedOption) => {
                                const event = {
                                    target: {
                                        name: 'annual_revenue',
                                        value: selectedOption,
                                    },
                                };
                                validation.handleChange(event);
                            }}
                            onBlur={() => {
                                validation.handleBlur({
                                    target: { name: 'annual_revenue' },
                                });
                            }}
                            value={validation.values.annual_revenue || ''}
                            invalid={
                                !!(validation.touched.annual_revenue
                                    && validation.errors.annual_revenue)
                            }
                        />
                            {validation.touched.annual_revenue
                            && validation.errors.annual_revenue ? (
                            <span className="text-danger">
                                {CONSTANTS.STR_REQUIRED_FIELD}
                            </span>
                        ) : null}
                    </Col>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Annual Payroll</Label>
                        <Select
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            menuShouldBlockScroll='true'
                            options={optionsRevenueOrPayRoll}
                            onChange={(selectedOption) => {
                                const event = {
                                    target: {
                                        name: 'annual_payroll',
                                        value: selectedOption,
                                    },
                                };
                                validation.handleChange(event);
                            }}
                            onBlur={() => {
                                validation.handleBlur({
                                    target: { name: 'annual_payroll' },
                                });
                            }}
                            value={validation.values.annual_payroll || ''}
                            invalid={
                                !!(validation.touched.annual_payroll
                                    && validation.errors.annual_payroll)
                            }
                        />
                            {validation.touched.annual_payroll
                            && validation.errors.annual_payroll ? (
                            <span className="text-danger">
                                {CONSTANTS.STR_REQUIRED_FIELD}
                            </span>
                        ) : null}
                    </Col>
                </Col>
            </Row>
            <Row>
                <div className="text-end mt-3">
                    <button
                        type="submit"
                        name="submit"
                        className={`btn ${getPrimaryButtonClass()} ms-2`}
                    >
                        Save
                    </button>
                    <button
                        type="button"
                        className="btn btn-light ms-2"
                        onClick={onCloseClick}
                    >
                        Cancel
                    </button>
                </div>
            </Row>
        </Form>
      </ModalBody>
    </Modal>
  )
}

AddBusinessEntityModal.propTypes = {
  onCloseClick: PropTypes.func,
  onClickBusinessEntity: PropTypes.func,
  show: PropTypes.any,
  title: PropTypes.any,
}

export default AddBusinessEntityModal;

